import { Box, Container, styled, Typography } from "@mui/material";
import { useEffect } from "react";
import PageTemplate from "../../components/template/page-template";
import { useAppDispatch } from "../../redux/store";
import { IWithClassName } from "../../theme/default.theme";
import ListToTrackSearchBar from "./components/list-to-track-search";
import TrackedListsTable from "./components/tracked-lists-table";
import { trackedListInitAction } from "./redux/tracked-lists.actions";

const TrackedList = ({ className }: IWithClassName) => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(trackedListInitAction());
    }, [dispatch]);

    return (
        <PageTemplate pageTitle="Tracked List">
            <Container className={className}>
                <Typography variant="h6" className="text-center">
                    TRACKED LISTS
                </Typography>
                <Box className="search-box">
                    <Typography>Search for a Tracked List to Add</Typography>
                    <ListToTrackSearchBar />
                </Box>
            </Container>
            <TrackedListsTable />
        </PageTemplate>
    );
};

export default styled(TrackedList)(({ theme }) => ({
    ".search-box": {
        margin: theme.spacing(4, 0),
        disply: "grid",
        ".MuiTypography-root": {
            padding: theme.spacing(1.2),
            fontWeight: "bold",
        },
    },
}));
